export default "__VITE_ASSET__22b38c3a__"